const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

const TvgServices = {
  init() {
    document.querySelectorAll<HTMLElement>('[data-tvg-services]').forEach((block) => {
      const sheets = Array.from(block.querySelectorAll<HTMLDialogElement>('[data-tvg-service-sheet]'))

      if (!sheets.length) {
        return
      }

      const pageUrl = block.dataset.url ?? window.location.pathname
      const pageTitle = block.dataset.title ?? document.title

      const show = (sheet: HTMLDialogElement) => {
        sheet.classList.remove('is-closing')

        sheets.forEach((other) => {
          if (other !== sheet && other.open) {
            other.close()
          }
        })

        if (!sheet.open) {
          sheet.showModal()
        }

        document.title = sheet.dataset.title ?? pageTitle
      }

      // The sheet slides back out before it closes.
      const hide = (sheet: HTMLDialogElement) => {
        if (!sheet.open || sheet.classList.contains('is-closing')) {
          return
        }

        if (reducedMotionMediaQuery.matches) {
          sheet.close()
          return
        }

        sheet.classList.add('is-closing')
        sheet.addEventListener('animationend', function done(event) {
          if (event.target !== sheet || event.animationName !== 'tvg-service-sheet-out') {
            return
          }

          sheet.removeEventListener('animationend', done)

          // Opened again while it was on its way out
          if (sheet.classList.contains('is-closing')) {
            sheet.classList.remove('is-closing')
            sheet.close()
          }
        })
      }

      // A sheet rendered open, at the service's own URL, is made modal like one opened by a click.
      const initial = sheets.find((sheet) => sheet.open)

      if (initial) {
        initial.removeAttribute('open')
        show(initial)
      }

      // Opening a service puts its URL in the address bar, so it can be shared and Back closes it.
      block.querySelectorAll<HTMLAnchorElement>('[data-tvg-service-open]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const sheet = sheets.find((item) => item.id === link.getAttribute('aria-controls'))

          if (!sheet || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return
          }

          event.preventDefault()
          window.history.pushState({ tvgService: true }, '', sheet.dataset.url)
          show(sheet)
        })
      })

      sheets.forEach((sheet) => {
        sheet.querySelector('[data-tvg-service-close]')?.addEventListener('click', () => hide(sheet))

        // Escape closes it the same way.
        sheet.addEventListener('cancel', (event) => {
          event.preventDefault()
          hide(sheet)
        })

        // The sheet fills the dialog, so a click on the dialog itself is a click on the backdrop.
        sheet.addEventListener('click', (event) => {
          if (event.target === sheet) {
            hide(sheet)
          }
        })

        sheet.addEventListener('close', () => {
          if (sheet.open) {
            return
          }

          document.title = pageTitle

          if (window.location.pathname !== sheet.dataset.url) {
            return
          }

          // A sheet opened here goes back to the page; one the visitor arrived at swaps its URL for the page's.
          if (window.history.state?.tvgService) {
            window.history.back()
          } else {
            window.history.replaceState(null, '', pageUrl)
          }
        })
      })

      window.addEventListener('popstate', () => {
        const sheet = sheets.find((item) => item.dataset.url === window.location.pathname)

        if (sheet) {
          show(sheet)
          return
        }

        sheets.forEach(hide)
      })
    })
  },
}

export default TvgServices
